export const classList = (
  ...classes: (string | boolean | undefined)[]
): string => classes.filter(item => Boolean(item)).join(' ');
